import React, { useState, } from 'react';
import { isEmpty, } from 'lodash';
import { toast } from 'react-toastify';
import { multiFactor, } from 'firebase/auth';

import ProgressButton from './ProgressButton';
import MultiFactorEnrollButton, { handleMultiFactorError } from './MultiFactorEnrollButton';

export default function MultiFactorSettings(props) {
  const { firebaseUser, companies, } = props;
  const [enrolledFactors, setEnrolledFactors] = useState(multiFactor(firebaseUser).enrolledFactors);
  const requiringCompanies = companies.filter(_ => _.multiFactorRequired);
  const onClickUnenroll = async () => {
    if(!window.confirm('2段階認証を解除します。よろしいですか？')) return;

    try {
      await enrolledFactors.reduce(async (x, factor) => {
        await x;
        await multiFactor(firebaseUser).unenroll(factor);
      }, Promise.resolve());
      setEnrolledFactors(multiFactor(firebaseUser).enrolledFactors);
      toast.success('2段階認証を解除しました');
    } catch(e) {
      await handleMultiFactorError(e);
    }
  };

  return (
    <div>
      <div className="text-muted small">2段階認証</div>
      <div className="d-flex align-items-center justify-content-between">
        {
          isEmpty(enrolledFactors) ? (
            <>
              <div>未設定</div>
              <MultiFactorEnrollButton size="sm" firebaseUser={firebaseUser} onEnrolled={() => setEnrolledFactors(multiFactor(firebaseUser).enrolledFactors)} />
            </>
          ) : (
            <>
              <div>
                <span className="fas fa-shield-alt text-success mr-1" />
                認証アプリで設定済み
              </div>
              <ProgressButton color="danger" outline size="sm" process={onClickUnenroll} disabled={requiringCompanies.length > 0}>解除する</ProgressButton>
            </>
          )
        }
      </div>
      {
        !isEmpty(enrolledFactors) && requiringCompanies.length > 0 && (
          <div className="small text-muted mt-2">
            2段階認証が必須の事業所に所属しているため解除できません（{requiringCompanies.map(_ => _.display_name).join('、')}）
          </div>
        )
      }
    </div>
  );
};
